export const GOOGLE_MAP_API_KEY = 'AIzaSyDfeLiy_dEZhXa82IFiVxurfhUZ2jkU8_0'
